<template><v-dialog v-model="dialog" persistent max-width="900px">
  <v-card  flat class="fixed-card d-flex flex-column">
    <div>
    </div>
        <v-toolbar dense dark fixed class="sticky-toolbar">
        <v-card-title>
          Release Notes
        </v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="firstPage()">
            <v-icon>&lt;&lt;</v-icon>
          </v-btn>
          <v-btn icon @click="prevPage(page)">
            <v-icon> &lt; </v-icon>
          </v-btn>
          <span>{{ page }}</span>
          <v-btn icon @click="changePage(page)">
            <v-icon>></v-icon>
          </v-btn>
          <v-btn icon @click="endPage()">
            <v-icon>>></v-icon>
          </v-btn>
        </v-toolbar>
        <pdf
          v-bind:src="pdfSrc"
          :page=page
          style="width: 100%"
          @num-pages="numPages = $event"
        ></pdf>        
        
        <div class="flex-grow-1"></div> <!-- This pushes the content below it to the bottom -->

        <v-card-actions class="d-flex align-center">
          <v-spacer></v-spacer>
          <v-btn color="black darken-1" text @click="close()">close</v-btn>
        </v-card-actions>
      </v-card>
</v-dialog>
</template>

<script>
import axios from 'axios';
import pdf from 'vue-pdf';
export default {
  data() {
    return {
      dialog: false,
      pdfSrc: '', // Set the path to your PDF file
      loadedRatio: 0,
      page: 1,
      numPages: 0,
      rotate: 0,
    };
  },
  components:{
    pdf
  },
  methods: {
    async open() {
      this.dialog = true;
      console.log('here')
      await this.getPDF()
    },
    close() {
      this.dialog = false;
      this.pdfSrc = ''
    },
     async getPDF() {
      const data = JSON.stringify(
        {
          company: 'massprinting',
          fileName: 'ReleaseNotes.pdf',
        },
      );
      const config = {
        method: 'post',
        url: process.env.VUE_APP_API_GETPDF_URL,
        headers: {
          'x-api-key': process.env.VUE_APP_API_KEY,
          'Content-Type': 'application/json',
        },
        data,
      };
      try {
        const response = await axios(config);
        console.log(response)
        this.pdfSrc = response.data;
      } catch(e) {
        console.log(e)
      }
    },
    changePage(curPage) {
      if (curPage === this.numPages) this.page = curPage;
      else this.page = curPage + 1;
    },
    prevPage(curPage) {
      if (curPage === 1) this.page = curPage;
      else this.page = curPage - 1;
    },
    firstPage() {
      this.page = 1;
    },
    endPage() {
      this.page = this.numPages;
    },
  },
  computed: {
  }
};
</script>
